import {get} from 'lodash';

import {getDateUtilDefaultInstance} from '/util/date.util';

export const handleMaintenanceBanner = (maintenance: any) => {
  // Handling the default title value like this because the default value param in
  // get method is not rendering the default value correctly.
  const title =
    get(maintenance, 'warning.title') || 'App maintenance scheduled';
  const dateUtil = getDateUtilDefaultInstance();
  const startMaintenanceDate = get(
    maintenance,
    'page.startMaintenanceDate',
    null,
  );
  const endMaintenanceDate = get(maintenance, 'page.endMaintenanceDate', null);
  const startBannerDate = get(maintenance, 'warning.startWarningDate', null);
  const endBannerDate = get(maintenance, 'warning.endWarningDate', null);
  const localStartDate = dateUtil
    .formatUTC(new Date(startMaintenanceDate))
    .toLocaleString();
  const localEndDate = dateUtil
    .formatUTC(new Date(endMaintenanceDate))
    .toLocaleString();
  const isWithinRange = dateUtil.isDateWithinRange(
    startBannerDate,
    endBannerDate,
  );
  const description = get(maintenance, 'warning.description');
  return {
    isWithinRange,
    title,
    description,
    localStartDate,
    localEndDate,
  };
};
